/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { useSelector, useDispatch } from 'react-redux'
import $t from '../../../i18n'
import Actions from '../../../actions'
import { capitalize } from 'lodash'
import {
  htnSideMenuDisplay,
  mhSideMenuDisplay,
  isReferredToClinic,
  diabetesSideMenuDisplay,
} from '../../../utils/clinicsUtils'
import { clinicTypes, routes } from '../../../consts'
import cx from 'classnames'
import Alert from '../../common/Alert'
import logo from '../../../resources/logo.svg'
import minimizeMenu from '../../../resources/Menu_Grey.png'
import { canView } from '../../../utils/accountPermissionsUtils'
import { MenuRoutes } from '../Routes'
// TODO - add it back when we will design new menu (NOT FOR MVP)
// import MaterialInput from '../../common/MaterialInput'
import SwitchLanguage from '../../common/SwitchLanguage'

import './SideMenu.css'
import { event, eventTypes } from '../../../consts/eventConsts'

const SideMenu = () => {
  const dispatch = useDispatch()
  const currentLocation = useLocation()
  const isProvidersPage = currentLocation.pathname.includes('providers')

  const { userDetails, isUserDetailsLoading } = useSelector(
    state => state?.profile
  )

  const permissions = useSelector(state => state.account?.permissions)
  const [medicalMenuItems, setMedicalMenuItems] = useState(
    MenuRoutes?.filter(item =>
      item?.filter ? item?.filter(userDetails) : true
    )
  )
  const selectedMember = useSelector(state => state.account?.selectedMember)
  const htnDisplay = useSelector(state => htnSideMenuDisplay(state))
  const mhDisplay = useSelector(state => mhSideMenuDisplay(state))
  const diabetesDisplay = useSelector(state => diabetesSideMenuDisplay(state))

  const [shouldShowAlert, setShouldShowAlert] = useState(false)
  const [isMinimize, setIsMinimize] = useState(true)

  const activeMembers = useSelector(state => state.account?.activeMembers)
  const isWithFamily = activeMembers?.length

  const patientReferredToHtn = useSelector(state =>
    isReferredToClinic(state, clinicTypes.HTN)
  )
  const patientReferredToMH = useSelector(state =>
    isReferredToClinic(state, clinicTypes.MENTAL)
  )

  const patientReferredToDm = useSelector(state =>
    isReferredToClinic(state, clinicTypes.DIABETES)
  )

  useEffect(() => {
    setMedicalMenuItems(
      MenuRoutes?.filter(item =>
        item?.filter ? item?.filter(userDetails) : true
      )
    )
  }, [userDetails])

  const firstName = userDetails?.firstName

  const onFutureVisitsPressed = useCallback(() => {
    dispatch(
      Actions.createAction(Actions.NAVIGATED_TO, '/medical-visits/future')
    )
  }, [])

  const startHypertension = useCallback(() => {
    dispatch(Actions.createAction(Actions.HYPERTENSION_CLICKED))
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        eventName: Actions.HYPERTENSION_CLICKED + '_WEB',
        data: {
          from: 'Hamburger Menu',
          acceptedReferral: patientReferredToHtn,
        },
      })
    )
  }, [])

  const startHTNFollowupBot = () => {
    dispatch(Actions.createAction(Actions.OPEN_HTN_FOLLOW_UP_BOT_SCREEN))
  }
  const startDMFollowupBot = () => {
    dispatch(Actions.createAction(Actions.OPEN_DM_FOLLOW_UP_BOT_SCREEN))
  }

  const onHyperTensionPressed = useCallback(() => {
    switch (htnDisplay) {
      case $t('sideMenu.clinics.nextAppointments'):
        onFutureVisitsPressed()
        break
      case $t('sideMenu.bookFollowup'):
      case $t('sideMenu.followUpIntake'):
        startHTNFollowupBot()
        break
      default:
        startHypertension()
        break
    }
  }, [htnDisplay])

  const startMentalHealth = useCallback(() => {
    dispatch(Actions.createAction(Actions.MENTALHEALTH_CLICKED))
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        eventName: Actions.MENTALHEALTH_CLICKED + '_WEB',
        data: {
          from: 'Hamburger Menu',
          acceptedReferral: patientReferredToMH,
        },
      })
    )
  }, [])
  const startDiabetes = useCallback(() => {
    dispatch(Actions.createAction(Actions.DIABETES_CLICKED))
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        eventName: Actions.DIABETES_CLICKED + '_WEB',
        data: {
          from: 'Hamburger Menu',
          acceptedReferral: patientReferredToDm,
        },
      })
    )
  }, [])

  const onMentalHealthPressed = useCallback(() => {
    switch (mhDisplay) {
      case $t('sideMenu.clinics.nextAppointments'):
        onFutureVisitsPressed()
        break
      case $t('sideMenu.clinics.bookFollowup'):
        setShouldShowAlert(true)
        break
      default:
        startMentalHealth()
        break
    }
  }, [mhDisplay])

  const onDiabetesPressed = useCallback(() => {
    switch (diabetesDisplay) {
      case $t('sideMenu.clinics.nextAppointments'):
        onFutureVisitsPressed()
        break
      case $t('sideMenu.followUpIntake'):
      case $t('sideMenu.clinics.bookFollowup'):
        startDMFollowupBot()
        break
      default:
        startDiabetes()
        break
    }
  }, [diabetesDisplay])

  const handleMenuItem = (item, index, setFunc, subIndex) => {
    if (!item.children) {
      if (item?.action) {
        dispatch(Actions.createAction(item?.action))
      } else if (item?.path) {
        dispatch(Actions.createAction(Actions.NAVIGATED_TO, item.path))
      } else if (item?.name === clinicTypes.HTN) {
        onHyperTensionPressed()
      } else if (item?.name === clinicTypes.MENTAL) {
        onMentalHealthPressed()
      } else if (item?.name === clinicTypes.DIABETES) {
        onDiabetesPressed()
      }
      setIsMinimize(true)
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          type: eventTypes.click,
          eventName: event.clickEvent.click,
          element: item?.name,
        })
      )
    }

    // mark the item pressed - active. The others, not active.
    setFunc(prev => {
      let newArr = prev.map(item => ({ ...item, active: false }))
      newArr[index].active = item?.children ? !item.active : true
      if (subIndex) {
        const newSubMenus = newArr[index].children.map(subItem => ({
          ...subItem,
          active: false,
        }))
        newSubMenus[subIndex].active = true
        newArr[index].children = newSubMenus
      }
      return newArr
    })
  }

  const getSumMenuLabel = name => {
    if (name === clinicTypes.HTN) {
      return htnDisplay
    }
    if (name === clinicTypes.MENTAL) {
      return mhDisplay
    }
    if (name === clinicTypes.DIABETES) {
      return diabetesDisplay
    }
    return $t(name)
  }

  return (
    <div className={isMinimize ? 'side-menu' : 'side-menu open'}>
      <img
        src={logo}
        alt=""
        className="logo"
        onClick={() =>
          dispatch(Actions.createAction(Actions.NAVIGATED_TO, routes.ROOT))
        }
      />
      <img
        src={minimizeMenu}
        alt=""
        className="minimize-menu"
        onClick={() => setIsMinimize(!isMinimize)}
      />
      <i className="icon-ex close-menu" onClick={() => setIsMinimize(true)} />
      {/* TODO - NOT FOR MVP <MaterialInput
        name={$t('sideMenu.search')}
        className="search-input"
        iconClassName="icon-search"
      /> */}
      {!isUserDetailsLoading && (
        <div className="scroll">
          <div className="medical-info">
            <ul>
              {medicalMenuItems.map((item, index) => {
                const isNeedToDisable =
                  (item?.disabled ? item?.disabled(userDetails) : false) ||
                  (isWithFamily &&
                    item.isAvailablOnlyMe &&
                    selectedMember?.id !== userDetails?.id)
                if (!canView(item?.permissions, permissions)) return null
                return (
                  <div key={index} className="items-container">
                    <div
                      data-name={$t(item.name)}
                      style={
                        isNeedToDisable ? { opacity: 0.5 } : { opacity: 1 }
                      }
                      className={cx('list-item-container trackable', {
                        active: false,
                      })}
                      onClick={() =>
                        !isNeedToDisable
                          ? handleMenuItem(item, index, setMedicalMenuItems)
                          : null
                      }
                    >
                      <span
                        className="menu-item-icon icon-arrow-bold-right"
                        data-hidden={!item.children}
                      />
                      {item.name === 'sideMenu.claims' && isNeedToDisable ? (
                        <li>
                          {$t(item.name)}{' '}
                          <span className="tiny italic">
                            {' (' + $t('sideMenu.claimsNote') + ')'}
                          </span>
                        </li>
                      ) : (
                        <li> {$t(item.name)}</li>
                      )}
                    </div>
                    {item.children && !isNeedToDisable
                      ? item.children
                          ?.filter(item =>
                            item?.filter ? item?.filter(userDetails) : true
                          )
                          .map((submenu, subIndex) => {
                            if (!canView(submenu?.permissions, permissions))
                              return null
                            return (
                              <div
                                data-name={getSumMenuLabel(submenu.name)}
                                key={subIndex}
                                onClick={() =>
                                  handleMenuItem(
                                    submenu,
                                    index,
                                    setMedicalMenuItems,
                                    subIndex
                                  )
                                }
                                className={
                                  item.active
                                    ? 'submenu-item-active trackable'
                                    : 'submenu-item trackable'
                                }
                              >
                                {getSumMenuLabel(submenu.name)}
                              </div>
                            )
                          })
                      : null}
                  </div>
                )
              })}
            </ul>
            <div className="footer-menu">
              <SwitchLanguage />
              <div
                className="logout-option"
                onClick={() => {
                  // in case the location is on providers page, we need to navigate to the root page
                  // in order to avoid the user to be stuck on the providers page
                  if (isProvidersPage) {
                    dispatch(
                      Actions.createAction(Actions.NAVIGATED_TO, routes.ROOT)
                    )
                  }
                  dispatch(Actions.createAction(Actions.SIGNOUT_REQUESTED))
                }}
              >
                <i className="menu-item-icon icon-logout" />{' '}
                {$t('sideMenu.logout')}
              </div>
            </div>
          </div>
        </div>
      )}
      <Alert
        title={$t(
          'pages.getStarted.specialityServices.mh.followUpSupportMessage',
          { name: capitalize(firstName) }
        )}
        shouldDisplay={shouldShowAlert}
        onOk={() => setShouldShowAlert(false)}
      />
    </div>
  )
}

export default SideMenu
